/**
 * Date helpers — convert between ISO (yyyy-mm-dd, used by backend & state)
 * and display format (dd/mm/yyyy, used by users).
 */

const pad2 = (n) => String(n).padStart(2, '0');

// "2026-02-24" → "24/02/2026". Returns "" for falsy input.
export const isoToDisplay = (iso) => {
  if (!iso) return '';
  const m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return iso;
  return `${m[3]}/${m[2]}/${m[1]}`;
};

// "24/02/2026" → "2026-02-24". Returns "" for invalid input.
export const displayToIso = (display) => {
  if (!display) return '';
  const m = String(display).match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (!m) return '';
  const day = parseInt(m[1], 10);
  const mon = parseInt(m[2], 10);
  const year = parseInt(m[3], 10);
  if (mon < 1 || mon > 12 || day < 1 || day > 31) return '';
  return `${year}-${pad2(mon)}-${pad2(day)}`;
};

export const todayIso = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
};
